// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsAnticipations_ByRecebimentoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /payments/anticipations/by_recebimento/{id}
 *
 * Returns a list of anticipation rows linked to the given recebimento,
 * each enriched with display values. Per-row shape mirrors payment_anticipations
 * joined with the recebimentos_anticipations link row — see
 * SubaccountsAnticipations_ByRecebimentoRow.
 */
import type { SubaccountsAnticipations_ByRecebimentoRow } from './SubaccountsAnticipations_ByRecebimentoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type SubaccountsAnticipations_ByRecebimentoResponseDados = SubaccountsAnticipations_ByRecebimentoRow[];

export type SubaccountsAnticipations_ByRecebimentoResponse = ApiResponse<SubaccountsAnticipations_ByRecebimentoResponseDados>;

registerResponseContract('SubaccountsAnticipations_ByRecebimentoResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      id:                         { type: 'number',  required: true },
      subaccount_id:              { type: 'number',  required: true },
      payment_link_id:            { type: 'number',  required: false },
      provider_code:              { type: 'string',  required: true },
      provider_anticipation_id:   { type: 'string',  required: true },
      provider_payment_id:        { type: 'string',  required: false },
      provider_installment_id:    { type: 'string',  required: false },
      status:                     { type: 'string',  required: true },
      request_date:               { type: 'string',  required: true },
      anticipation_date:          { type: 'string',  required: false },
      due_date:                   { type: 'string',  required: false },
      anticipation_days:          { type: 'number',  required: false },
      total_value:                { type: 'number',  required: true },
      anticipation_value:         { type: 'number',  required: true },
      fee:                        { type: 'number',  required: true },
      net_value:                  { type: 'number',  required: true },
      denial_observation:         { type: 'string',  required: false },
      is_automatic:               { type: 'number',  required: true },
      created_at:                 { type: 'string',  required: true },
      updated_at:                 { type: 'string',  required: true },
      last_synced_at:             { type: 'string',  required: false },
      linked_at:                  { type: 'string',  required: true },
      linked_by_user_id:          { type: 'string',  required: false },
      total_value_display:        { type: 'number',  required: true },
      anticipation_value_display: { type: 'number',  required: true },
      fee_display:                { type: 'number',  required: true },
      net_value_display:          { type: 'number',  required: true },
    },
  },
})
